import { ActionBase } from '../../../core/store/action/ActionBase';
import { DynamicDataSetModel } from '../../models/DynamicDataSetModel';

export const FINALIZE_DYNAMICDATASET_SUCCESS = '[DynamicDataSet] Finalize Success';

export class FinalizeDynamicDataSetSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = FINALIZE_DYNAMICDATASET_SUCCESS;

  constructor(public payload: { dynamicDataSet: DynamicDataSetModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/FinalizeDynamicDataSetSuccessAction.ts